import { createEvent, createStore } from 'effector';

export type ProfileRole = 'regwait' | 'worker' | 'carder' | 'partner' | 'admin';
export type PanelRole = Exclude<ProfileRole, 'regwait'>;

export interface IProfile {
	id: number;
	userId: number;

	role: ProfileRole;
	nickname: string;

	profitAmount: number;
	profitCount: number;

	createdAt: number;
}

export const $setProfile = createEvent<IProfile>();
export const $updateProfile = createEvent<Partial<IProfile>>();
export const $resetAuth = createEvent();

export const $profile = createStore<IProfile | null>(null)
	.on($setProfile, (_, payload) => payload)
	.on($updateProfile, (state, payload) => (state ? { ...state, ...payload } : state))
	.reset($resetAuth);

export const $setNickname = createEvent<string | null>();
export const $nickname = createStore<string | null>(null).on($setNickname, (_, payload) => payload).reset($resetAuth);
